module.exports = __webpack_public_path__ + "img/vignettes-asso_0006_20-ans-1-projet.98d0151d.jpg";